var map = {
	"./en-US": [
		"2886",
		3,
		"lang-en-US"
	],
	"./en-US.json": [
		"2886",
		3,
		"lang-en-US"
	],
	"./font-tools-other": [
		"d911",
		3,
		"lang-font-tools-other"
	],
	"./font-tools-other.json": [
		"d911",
		3,
		"lang-font-tools-other"
	],
	"./font-tools-zh-CN": [
		"193e",
		3,
		"lang-font-tools-zh-CN"
	],
	"./font-tools-zh-CN.json": [
		"193e",
		3,
		"lang-font-tools-zh-CN"
	],
	"./languageNamesMap": [
		"c4b2",
		9
	],
	"./languageNamesMap.js": [
		"c4b2",
		9
	],
	"./zh-CN": [
		"5c8a",
		3,
		"lang-zh-CN"
	],
	"./zh-CN.json": [
		"5c8a",
		3,
		"lang-zh-CN"
	],
	"./zh-TW": [
		"9546",
		3,
		"lang-zh-TW"
	],
	"./zh-TW.json": [
		"9546",
		3,
		"lang-zh-TW"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2118";
module.exports = webpackAsyncContext;